module.exports = __webpack_public_path__ + "img/ranking-three.fdba6b8b.png";